// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QiSct","leftBorder":"styles_leftBorder__EmWql"};